import { Colors, Text } from '@amelio/ui-library';

import type { ReactNode } from 'react';

import { useAmelioTranslations } from '@/hooks';

interface AgendaHeaderProps {
    totalMeetingTimeMinutes: number;
    /** Replaces the default (cycle-review) title and description, for a flow that titles its
     * sections its own way. */
    heading?: ReactNode;
}

export const AgendaHeader = ({ totalMeetingTimeMinutes, heading }: AgendaHeaderProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'flex flex-wrap items-start justify-between gap-4'}>
            {heading ?? (
                <div className={'flex flex-col gap-2'}>
                    <Text
                        weight={'medium'}
                        color={Colors.BASE_600}
                        className={'text-2xl'}
                    >
                        {t('meetingAgenda.title')}
                    </Text>

                    <Text
                        size={'small'}
                        color={Colors.BASE_400}
                        className={'max-w-3xl'}
                    >
                        {t('meetingAgenda.description')}
                    </Text>
                </div>
            )}

            <div
                className={
                    'border-primary/30 bg-primary-50 flex items-center gap-2 rounded-lg border px-4 py-2'
                }
                data-testid={'meeting-agenda-total-time'}
            >
                <Text
                    size={'small'}
                    weight={'medium'}
                    color={Colors.BASE_600}
                >
                    {t('meetingAgenda.totalMeetingTime')}
                </Text>

                <Text
                    size={'large'}
                    weight={'semibold'}
                    color={Colors.PRIMARY}
                >
                    {t('meetingAgenda.minutes', { count: totalMeetingTimeMinutes })}
                </Text>
            </div>
        </div>
    );
};

export default AgendaHeader;
